import React from 'react';
import { SimpleFormProvider } from '../fluidComponents/fluidForm/SimpleFormLoader';
import { Button } from 'semantic-ui-react';
import { MiniSite } from './MiniSite';
import { CodeBlock } from './CodeBlock';
export const Page = () => {
    return React.createElement(MiniSite, null);
};
export const NavigationChat = () => {
    const handleMessageReceived = (message) => {
        console.log("handleMessageReceived", message);
        if (message.data?.actionPath) {
            const steps = message?.data?.actionPath || [];
            const keys = steps.map(s => s.componentKey);
            const last = steps[steps.length - 1]?.highlightText;
            console.info("Navigating to", keys, last);
            navigate(keys, last);
            //navigate(['services'], 'At Love2Learn');
        }
    };
    const navigateToServices = () => {
        navigate(['services'], 'At Love2Learn');
    };
    const navigateToPersonalizedPlans = () => {
        navigate(['services'], 'Personalised Learning Plans');
    };
    return (React.createElement("div", { className: "space-y-5" },
        React.createElement("header", null,
            React.createElement("h1", { className: "text-xl font-semibold text-gray-900" }, "Navigation Chat"),
            React.createElement("p", { className: "text-gray-600 text-sm mt-1" }, "Demonstrates AI-driven navigation on a mock site using a chat agent. The chat emits an action path that is used to drive DOM navigation.")),
        React.createElement("section", { className: "space-y-3" },
            React.createElement("h2", { className: "text-sm font-semibold text-gray-800" }, "Usage"),
            React.createElement(CodeBlock, { language: "tsx", code: `<SimpleFormProvider
  formKey=\"basic1\"
  submissionId=\"example-1\"
  signature={\"<org-or-app-signature>\"}
  onMessageReceived={(msg) => {
    const steps = (msg as any)?.data?.actionPath || [];
    // navigate( ... )
  }}
  formProps={{ chatProps: { chatPath: 'chat-router' } }}
/>` })),
        React.createElement("section", { className: "space-y-3" },
            React.createElement("div", { className: "flex gap-2" },
                React.createElement(Button, { primary: true, onClick: navigateToServices }, "Services"),
                React.createElement(Button, { primary: true, onClick: navigateToPersonalizedPlans }, "Personalized Plans")),
            React.createElement(Page, null),
            React.createElement(SimpleFormProvider, { formKey: "basic1", onSubmit: () => { }, submissionId: "example-1", signature: 'org_2xvQWE6viGwyWWsfH4JCmW1np0H-basic-ba28e8c1beb64fe9', onMessageReceived: handleMessageReceived, formProps: {
                    chatProps: {
                        chatPath: "chat-router",
                    }
                } }))));
};
export function navigate(path, highlightText) {
    if (!Array.isArray(path) || path.length === 0)
        return;
    let lastElement = null;
    for (const key of path) {
        const el = document.querySelector(`[data-navigationKey="${key}"], [data-navigationkey="${key}"], #${key}`);
        if (el) {
            el.click();
            lastElement = el;
        }
    }
    if (lastElement) {
        // Scroll into view
        lastElement.scrollIntoView({ behavior: "smooth", block: "center" });
        if (highlightText) {
            const walker = document.createTreeWalker(lastElement, NodeFilter.SHOW_TEXT, {
                acceptNode: (node) => node.nodeValue && node.nodeValue.includes(highlightText)
                    ? NodeFilter.FILTER_ACCEPT
                    : NodeFilter.FILTER_SKIP,
            });
            const textNode = walker.nextNode();
            if (textNode) {
                const range = document.createRange();
                const startIndex = textNode.nodeValue.indexOf(highlightText);
                range.setStart(textNode, startIndex);
                range.setEnd(textNode, startIndex + highlightText.length);
                const highlight = document.createElement("span");
                highlight.className = "temp-highlight";
                range.surroundContents(highlight);
                highlight.scrollIntoView({ behavior: "smooth", block: "center" });
                // trigger fade-out via CSS after 50ms
                setTimeout(() => {
                    highlight.classList.add("fade-out");
                }, 50);
            }
        }
    }
}
export default NavigationChat;
